/**
 * When a project last mattered, for "Last visited" and Home's recent projects: the LATEST of the dates it has, not the
 * first one present. A project opened last week but edited, published or deployed today (vfs-service dates it by its
 * newest event) is newer than one only opened yesterday. A project with no date at all is the oldest.
 */
export function lastActivityMs(project) {
  const dates = [project?.visitedAt, project?.updatedAt, project?.createdAt]
    .map((value) => (value ? new Date(value).getTime() : 0))
    .filter((ms) => Number.isFinite(ms));
  return dates.length ? Math.max(...dates) : 0;
}

/** The ISO date lastActivityMs picked, for the relative time shown next to a project ("2 hours ago"). */
export function lastActivityAt(project) {
  const ms = lastActivityMs(project);
  return ms ? new Date(ms).toISOString() : null;
}
